import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";

import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { UserNotificationRepository } from "@app/core/notifications/domain/user-notification.repository";

@Injectable({
  providedIn: "root",
})
export class ReadNotificationUseCase {
  constructor(
    private tokenRepo: TokenRepo,
    private notificationsRepo: UserNotificationRepository
  ) {}
  execute(id: number): Observable<void> {
    const token = this.tokenRepo.get();
    if (token == null) {
      return throwError(() => new MissingCredentialsError());
    }

    return this.notificationsRepo.readNotification(id, token);
  }
}
